import React, { useState } from "react";
import { Button } from "react-bootstrap";
import HideShowMileStoneButtton from "./HideShowMilestoneButton";

const MilestoneButton = props => {
  const {
    _selectedBucketData,
    onMilestoneButtonClick,
    onMilestoneUpdated,
    isMilestoneEdit,
    projectMilestoneStatus,
    projectDetailBucketMilestoneCOS,
    onClickOfSaveAsDraft,
    idOfProject
  } = props;

  const [isMilstoneUpdated, setisMilstoneUpdated] = useState(false);

  const onClickOfShowMilestone = showPhaseOnBucketComplete => {
    onMilestoneButtonClick(showPhaseOnBucketComplete);
  };

  const onClickOfUpdateButton = () => {
    setisMilstoneUpdated(true);
    onMilestoneUpdated(isMilstoneUpdated);
  };

  const onClickOfDraftButton = () => {
    onClickOfSaveAsDraft();
  };
  return (
    <div
      className={`${
        _selectedBucketData &&
        _selectedBucketData.completed &&
        isMilestoneEdit &&
        idOfProject
          ? "milestone-buttons d-flex justify-content-between"
          : ""
      }`}
    >
      {_selectedBucketData &&
        _selectedBucketData.completed &&
        isMilestoneEdit &&
        idOfProject && (
          <>
            <div className="d-flex">
              <Button className="btn-orange" onClick={onClickOfUpdateButton}>
                {projectMilestoneStatus === "DRAFT" ||
                (projectDetailBucketMilestoneCOS &&
                  !projectDetailBucketMilestoneCOS.length)
                  ? "Submit"
                  : "Update"}
              </Button>
              {projectMilestoneStatus === "DRAFT" && (
                <Button
                  className="btn-orange-invert btn-draft-milestone"
                  onClick={onClickOfDraftButton}
                >
                  Save as Draft
                </Button>
              )}
            </div>
            <HideShowMileStoneButtton
              onMilestoneButtonClick={onClickOfShowMilestone}
            />
          </>
        )}
    </div>
  );
};

export default MilestoneButton;
